/**
 * Safely extract a human-readable error message from an unknown error value.
 *
 * Handles Error instances, API error objects with `detail` or `message` fields,
 * and arbitrary values by coercing to string.
 */
export function extractErrorMessage(error: unknown, fallback = "An error occurred"): string {
    if (error instanceof Error) return error.message;
    if (typeof error === "object" && error !== null) {
        const obj = error as Record<string, unknown>;
        if (typeof obj["detail"] === "string") return obj["detail"];
        if (typeof obj["message"] === "string") return obj["message"];
    }
    return String(error || fallback);
}
